import React from 'react';
import { Modal } from '@carbon/react';


const InformAboutLostChangesStreamNewModal = ({ hideModal }) => {
  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Fortfahren"
      secondaryButtonText="Abbrechen"
      modalHeading="Eventuell nicht gespeicherte änderungen gehen verloren."
      onRequestClose={hideModal}
      onRequestSubmit={() => {
        hideModal();
        //TODO: hideForm
        //dispatch(sideFormsActions.hideForm());
      }}></Modal>
  );
};

export default InformAboutLostChangesStreamNewModal;
